import { render } from "./ClientModal.vue?vue&type=template&id=87b7d644&scoped=true"
import script from "./ClientModal.vue?vue&type=script&lang=js"
export * from "./ClientModal.vue?vue&type=script&lang=js"

import "./ClientModal.vue?vue&type=style&index=0&id=87b7d644&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87b7d644"]])

export default __exports__